import * as React from 'react'
import Avatar from '@mui/material/Avatar'

export default function UserAvatar(params) {
  if (params.value == null) {
    return ''
  }

  return (
    <Avatar style={{ backgroundColor: params.value.color }}>
      {params.value.name.match(/([A-Z])/g)?.slice(0, 2).join('') || params.value.name.charAt(0)}
    </Avatar>
  )
}